// src/components/msteams-link-user/DefaultMsTeamsLinkUser.tsx
import { useMemo } from "react";
import { Mounter } from "../Mounter.js";
import { jsx } from "react/jsx-runtime";
var DefaultMsTeamsLinkUser = (props) => {
  const {
    integrationIdentifier,
    connectionIdentifier,
    context,
    onLinkSuccess,
    onLinkError,
    onUnlinkSuccess,
    onUnlinkError,
    linkLabel,
    unlinkLabel
  } = props;
  const mountProps = useMemo(
    () => ({
      integrationIdentifier,
      connectionIdentifier,
      context,
      onLinkSuccess,
      onLinkError,
      onUnlinkSuccess,
      onUnlinkError,
      linkLabel,
      unlinkLabel
    }),
    [
      integrationIdentifier,
      connectionIdentifier,
      context,
      onLinkSuccess,
      onLinkError,
      onUnlinkSuccess,
      onUnlinkError,
      linkLabel,
      unlinkLabel
    ]
  );
  return /* @__PURE__ */ jsx(Mounter, { name: "MsTeamsLinkUser", props: mountProps });
};
export {
  DefaultMsTeamsLinkUser
};
//# sourceMappingURL=DefaultMsTeamsLinkUser.js.map